import { ReactElement } from 'react';

import { isRenderingRepeatedFieldGroup, OnAnswerChange } from '@zinnia/form-engine-sdk';
import { Language } from '@breathelife/types';

import { BaseFieldProps, StyleVariant } from '../FieldGenerator/FieldGenerator';
import { Question } from './Question/Question';
import { RepeatableQuestion } from './Question/Repeatable/RepeatableQuestion';

export type WebQuestionProps = Omit<BaseFieldProps, 'locale' | 'currency'> & {
  onAnswerChange: OnAnswerChange;
  onAnswerComplete: (fieldId: string, answer: any, previousAnswer: any) => void;
  locale?: Language;
  styleVariant: StyleVariant;
  iconMap?: Record<string, string>;
  onInfoIconClick?: () => void;
  onError?: (fieldId: string, error?: string) => void;
  focusedIncompleteFieldId?: string;
};

export function WebQuestion(props: WebQuestionProps): ReactElement | null {
  const {
    fieldGroup,
    onAnswerChange,
    onAnswerComplete,
    locale,
    styleVariant,
    iconMap,
    onInfoIconClick,
    onError,
    focusedIncompleteFieldId,
  } = props;

  if (isRenderingRepeatedFieldGroup(fieldGroup)) {
    return (
      <RepeatableQuestion
        fieldGroup={fieldGroup}
        onAnswerChange={onAnswerChange}
        onAnswerComplete={onAnswerComplete}
        styleVariant={styleVariant}
        locale={locale}
        iconMap={iconMap}
        focusedIncompleteFieldId={focusedIncompleteFieldId}
      />
    );
  }

  return (
    <Question
      fieldGroup={fieldGroup}
      onAnswerChange={onAnswerChange}
      onAnswerComplete={onAnswerComplete}
      styleVariant={styleVariant}
      locale={locale}
      iconMap={iconMap}
      onInfoIconClick={onInfoIconClick}
      onError={onError}
      focusedIncompleteFieldId={focusedIncompleteFieldId}
    />
  );
}
